import { gql, TypedDocumentNode } from "@apollo/client";

import {
  DismissNotificationMutation,
  DismissNotificationMutationVariables,
} from "./DismissNotification.generated";

export const DISMISS_NOTIFICATION: TypedDocumentNode<
  DismissNotificationMutation,
  DismissNotificationMutationVariables
> = gql`
  mutation dismissNotification($notificationUuid: String!) {
    dismissNotification(notificationUuid: $notificationUuid) {
      ok
    }
  }
`;
